import { Flex } from "@pancakeswap-libs/uikit";
import styled from "styled-components";

const StyledHomeCard = styled(Flex)`
  width: 100%;
  max-width: 1200px;
  padding: 5em 2em;
  margin: 0 auto;
`

export default StyledHomeCard;